// src/App.js
import React from 'react';
import Map from './Map';

const App = () => {
    return (
        <div>
            <h1>Maplibre GL JS Map</h1>
            <Map />
        </div>
    );
};

export default App;
